import React from "react";
import { payCancel } from "../../assets";
import { Link } from "react-router-dom";

const PaymentCancel = () => {
  return (
    <div className="pay-failed">
      <img src={payCancel} alt="" />
      <div>
        <p>Payment Error</p>
        <small>Opps! See you later.</small>
        <Link to="/">Back to Home</Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
